exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-input-modal-header-container{padding-top:0px;padding-left:0px;padding-bottom:0px;min-height:9rem}.edit-input-modal-header-note{position:absolute;right:1rem;top:0px;display:flex;bottom:0px;flex-direction:column;justify-content:center;align-items:flex-end}.edit-input-modal-header-fallback{margin-top:3px}.edit-input-modal-header-fallback-options{color:white;text-align:right;padding-right:8px}.edit-input-modal-header-img{background-color:white;padding:5px 5px 6px 5px;border-top-left-radius:8px;top:0px !important;left:0px !important;right:10px}.edit-input-modal-header-deprecation{margin-top:1rem}\n", ""]);

// exports
